import React, { useEffect } from "react";
import SlideUpWrapper from "../../components/Transitions/SlideUpWrapper";
import { Icon } from 'react-icons-kit';
import { basic_mail } from 'react-icons-kit/linea/basic_mail'
import TopTitleBar from "../DashBoard/ExternalDash/TopTitleBar";
import { MESSAGE } from "../../Utils/Strings";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCart } from "../../Utils/Redux/CartSlice";

import styles from '../DashBoard/ExternalDash/Verifier/VerifyUsers.module.css'
import { AuthConsole } from "../../Utils/helper";

const CartCheckOut = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const User = useSelector(state => state.User)

    useEffect(() => {
        dispatch(fetchCart(User.user_id));
    }, [dispatch, User]);

    const data = location.state
    AuthConsole(data)
    if (data) {
        return (
            <SlideUpWrapper>
                <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton'>Payment Recieved</span></h2></TopTitleBar>
                <div className={styles.modal_content}>
                    <div className={styles.circle}>
                        <Icon icon={basic_mail} size={'3rem'} />
                    </div>
                    <h2>Request Sent</h2>
                    <p className={styles.successMessage}>{MESSAGE.REQUEST_ACCESS}</p>
                    <button className="btn btn-primary" onClick={() => navigate(User.category=="EMPLOYMENT"?'/dashboard/emp/requests':'/dashboard/forms/myRequests')}>View My Requests</button>
                </div>
            </SlideUpWrapper>
        );
    }
    else {
        return (
            <SlideUpWrapper>
                <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton'>Payment is not completed</span></h2></TopTitleBar>
                <div className={styles.modal_content}>
                    <div className={styles.circle}>
                        <Icon icon={basic_mail} size={'3rem'} />
                    </div>
                    <h2>Request not Sent</h2>
                    <p className={styles.successMessage}>{MESSAGE.REQUEST_ACCESS}</p>
                    <button className="btn btn-primary" onClick={() => navigate('/dashboard/cart')}>Go back</button>
                </div>
            </SlideUpWrapper>
        );
    }
};

export default CartCheckOut;
